import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'CNpayments',
    data () {
        return {
            admin:{},
            transactions: {},
            transaction: {},
            todays_count:0,
            panelFlag: false,
            viewFlag: false,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == "view"){
                this.viewFlag = true;
                this.transaction = attr2;
            }
        },
        
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        //quotes and contracts
        
        //get all saved listings
        getTransactions() {
            service.getTransactions(this).then(data => {
                if(data.body.status == 200) {
                    this.transactions = data.body.data;
                    this.todays_count = data.body.data_count_today;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        
        //paymoney
       
     
    },
    created: function(){
        this.preset();
        this.getTransactions();
    }
}


// WEBPACK FOOTER //
// ./src/components/CNpayments/script.js